import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import AboutExperienceImg1 from '../../assets/images/about/4.jpg';

const AboutExperienceData = [
    
    {
        id: uuidv4(),
        heading: 'Mission',
        description: 'We believe that every space—whether a home, office, or garden—deserves to shine. Our mission is to provide exceptional cleaning and gardening services that enhance the beauty, health, and functionality of your surroundings. By combining cutting-edge techniques, eco-friendly products, and a passion for perfection, we ensure that our clients enjoy spotless, refreshing spaces without the hassle. "A clean space is a happy space. A well-kept garden is a thriving sanctuary."'
    },

    {
        id: uuidv4(),
        heading: 'Vision',
        description: 'As a trusted leader in cleaning and landscaping, we envision a future where sustainability meets cleanliness through the use of green products that protect both families and the environment. We are dedicated to helping every garden flourish by delivering expert landscaping solutions that enhance curb appeal and promote biodiversity. Our clients enjoy hassle-free maintenance with flexible, reliable services customized to their unique needs. We continuously strive to innovate, inspire, and exceed expectations in every project we undertake, ensuring exceptional results that transform spaces into vibrant, healthy, and beautiful environments.',
    },

    {
        id: uuidv4(),
        heading: 'Goal',
        description: 'At the heart of our work lies a steadfast commitment to excellence. We prioritize customer satisfaction by delivering tailored, high-quality services designed to exceed expectations at every turn. Environmental responsibility guides our approach as we minimize chemical use and champion sustainable gardening practices that protect both people and the planet. Our team of professionals stays at the forefront of the industry through ongoing training in the latest cleaning techniques and horticultural innovations. Beyond individual services, we take pride in our positive community impact, working to create cleaner, greener neighborhoods where both nature and residents can thrive together.',
    },
    
];

const AboutExperienceItem = ({ heading, description, img }) => {
    return (
        <>
            <div className="single-experience">
                <h4>{heading}</h4>
                <p>{description}</p>
            </div>
        </>
    )
}

const AboutExperience = () => {
    return (
        <>
            <div className="experience-area pt-110 pb-110">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="section-title text-center mb-70">
                                <span>We Have Years of Experience</span>
                                <h2> Here’s a closer look at what guides our work </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-4 col-lg-6 col-md-6 offset-xl-2 offset-lg-2 offset-md-2">
                            {AboutExperienceData.map((data) => (
                                <AboutExperienceItem
                                    key={data.id}
                                    heading={data.heading}
                                    description={data.description}
                                />
                            ))}
                        </div>
                        <div className="col-xl-6 col-lg-6 col-lg-6 pl-85 pr-0">
                            <div className="experience-img">
                                <img src={AboutExperienceImg1} alt="" />
                                <div className="experience-small-block">
                                    <h5>We are Since 2020! </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutExperience;